/**
 * <LoginTerms> — ce qu'on accepte en se connectant (molecule).
 *
 * La mention posée sous le choix du moyen de connexion et sous le mot de passe. Le texte est le
 * même partout, il vit donc ici ; ouvrir les conditions est un effet, il est injecté.
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { Text } from "../../atoms/typography/Text"

export type LoginTermsProps = {
    /** Ouvre les conditions générales d'utilisation. */
    onOpenTerms?: () => void
    testID?: string
}

export function LoginTerms(props: LoginTermsProps) {
    const { onOpenTerms, testID } = props

    return (
        <Text testID={testID} size="text-sm" color="text-muted" center>
            En me connectant, j'accepte les{" "}
            <Text
                size="text-sm"
                weight="medium"
                color="primary"
                onPress={onOpenTerms}
                accessibilityRole="link"
                style={styles.link}
            >
                Conditions générales d'utilisation
            </Text>{" "}
            de Masteur. Je confirme avoir plus de 15 ans. Dans le cas contraire, je confirme avoir l'autorisation d'un
            parent pour utiliser ce service.
        </Text>
    )
}

const styles = StyleSheet.create(() => ({
    link: {
        textDecorationLine: "underline",
    },
}))
